import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import { PageTitle } from '../../../../_metronic/layout/core'
import { useContext } from 'react';
import './Dashboard.css';
import IndicadoresVentas from './IndicadoresVentas';
import GraficoVentas from './GraficoVentas';
import { SessionContext } from '../../../Components/Context/SessionContext';
import UserIdAuthorized from '../../../api/UserIdAuthorized';



export default function Dashboard({ title }) {
    const { session, setSession } = useContext(SessionContext);
    const idLocatario = (localStorage.getItem('idLocatario')) ? localStorage.getItem('idLocatario') : session.idUsuarioLocatario
    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.DASHBOARD_LOCATARIO]} >
                <UserIdAuthorized>

                    <PageTitle>{title}</PageTitle>

                    <div className="mb-5 mb-xl-8">
                        <div className="card-body py-3">
                            <h3 className="fw-bolder mb-6 mt-6">Ventas</h3>
                            <IndicadoresVentas idLocatario={idLocatario}></IndicadoresVentas>
                        </div>
                    </div>

                    {
                        //GRAFICO VENTAS
                        <GraficoVentas idLocatario={idLocatario}></GraficoVentas>
                    }

                </UserIdAuthorized>

            </PermissionsGate>
        </>
    )
}